import { render, staticRenderFns } from "./AddHomework.vue?vue&type=template&id=85bba018&scoped=true&"
import script from "./AddHomework.vue?vue&type=script&lang=js&"
export * from "./AddHomework.vue?vue&type=script&lang=js&"
import style0 from "./AddHomework.vue?vue&type=style&index=0&id=85bba018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85bba018",
  null
  
)

export default component.exports